// extracted by mini-css-extract-plugin
module.exports = {"grid":"serviceType-grid_grid__Blxbn"};